// extracted by mini-css-extract-plugin
module.exports = {"horizontalDivider":"az_uOc","container":"az_vOc","title":"az_wOc","description":"az_xOc"};